import { render, staticRenderFns } from "./Account.vue?vue&type=template&id=7951b7ea"
import script from "./account.js?vue&type=script&lang=js&external"
export * from "./account.js?vue&type=script&lang=js&external"
import style0 from "./account.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports